;(function () {
  'use strict'

  angular
    .module('contrast.available-languages')
    .factory('AvailableLanguagesService', AvailableLanguagesService)

  function AvailableLanguagesService(
    FeaturesService,
    featureFlags,
    LanguagesService
  ) {
    'ngInject'

    return {
      get: get
    }

    function get() {
      return FeaturesService.loadFeatureFlags()
        .then(function () {
          var lookup = {}
          LanguagesService.getAllAsArray().forEach(function (langObj) {
            lookup[langObj.value] = langObj.featureKey
              ? featureFlags.isOn(langObj.featureKey)
              : true
          })
          return lookup
        })
        .then(function (enabledLanguages) {
          return LanguagesService.getAllAsArray().filter(function (lang) {
            return enabledLanguages[lang.value]
          })
        })
    }
  }
})()
